import { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";

import { LoadingSkeleton } from "@narmi/design_system";

import { PermissionedRoutes } from "../../components/PermissionedRoutes";

const DeconversionsManagerPage = lazy(() =>
  import("./DeconversionsManagerPage").then((module) => ({
    default: module.DeconversionsManagerPage,
  }))
);

export const DECONVERSIONS_ROUTES: RouteObject[] = [
  {
    element: <PermissionedRoutes requiredFeatures={["deconversions"]} requiredRoles={["narmi"]} />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingSkeleton isLoading />}>
            <DeconversionsManagerPage />
          </Suspense>
        ),
      },
    ],
  },
];
